let importCounter = 0

export const combineSkillsWithImportedSkills = ( importedSkills, skills, trainings ) => {
	importCounter += 1
	const filteredImport = importedSkills.reduce( ( carry, impSkill ) => {
		if ( typeof impSkill.trainingId === "number" ) {
			const skillId = createSkillId( impSkill.trainingId )
			const trainingExists = skills.findIndex( skill => skill.id === skillId ) !== -1
			if ( !trainingExists ) {
				const training = trainings.find( tr => tr.id === impSkill.trainingId )
				if ( training ) {
					carry.push( {
						id: skillId,
						skillType: "training",
						trainingId: impSkill.trainingId,
						name: training.name,
						enabled: true,
						skillsGroup: training.skills_group,
						training: training,
					} )
				}
			}
		} else {
			const newSkill = { ...impSkill, id: `imp_${importCounter}_${impSkill.id}` }

			carry.push( newSkill )
		}
		return carry
	}, [] )

	return [ ...skills, ...filteredImport ]
}

let idCounter = 0

export const createSkillId = (
	trainingId,
) => {
	if ( typeof trainingId === "number" ) {
		return `tr_${trainingId}`
	}
	idCounter += 1
	return `sk_${idCounter}`
}
